import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { RegistrationApprovalFormPresentation } from './registration-approval-form.presentation';
import { RegistrationApprovalFormVM } from './registration-approval-form.viewmodel';

interface IProps {
    vm: RegistrationApprovalFormVM;
}

const RegistrationApprovalFormContainer = withViewModel(
    RegistrationApprovalFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { RegistrationApprovalFormContainer as RegistrationApprovalForm };